__turbopack_context__.v({
  "className": "dm_sans_350295c3-module__VXeFTW__className",
  "variable": "dm_sans_350295c3-module__VXeFTW__variable",
});
